import { FC, useContext } from 'react';

// Utils
import { ConfigContext } from '@velinsi/smp-widgets-ui';
import { getLabelValue } from '@sportal365/smp-widget-utils';

export const RankingTableHeader: FC = () => {
  const { dataLabels } = useContext(ConfigContext);

  return (
    <thead className='table-header'>
      <tr className='flex items-center justify-between md:justify-between w-full bg-subHeaderBgColor text-4 text-hiContrast h-[40px] xxs:px-3'>
        <th className='header-row-0-cell-RANK-NAME flex content-center sticky left-0 w-52 overflow-hidden bg-subHeaderBgColor'>
          <span className='column-rank w-9'>#</span>
          <span className='column-name'>{getLabelValue(dataLabels?.name, 'Name')}</span>
        </th>
        <th className='header-row-0-cell-NATIONALITY flex items-start xxs:justify-center md:justify-start xxs:text-ellipsis xxs:overflow-hidden md:text-wrap md:overflow-auto xxs:w-12 xs:w-20 sm:w-24 md:w-40'>
          <span className='column-nationality-desktop xxs:hidden md:block'>{getLabelValue(dataLabels?.nationality, 'Nationality')}</span>
          <span className='column-nationality-mobile md:hidden'>{getLabelValue(dataLabels?.nationality_short, 'Nat')}</span>
        </th>

        <th className='header-row-0-cell-POINTS md:w-24 xxs:w-12 xxs:text-ellipsis xxs:overflow-hidden md:text-wrap md:overflow-auto'>
          <span className='column-points-desktop xxs:hidden md:block'>{getLabelValue(dataLabels?.points, 'Points')}</span>
          <span className='column-points-mobile md:hidden'>{getLabelValue(dataLabels?.points_short, 'Pts')}</span>
        </th>
      </tr>
    </thead>
  );
};
